import { defineMessage } from '@lingui/macro';

export const DEACTIVATED = 'DEACTIVATED';
export const MANUAL_ADDED = 'MANUAL_ADDED';
export const SYSTEM_ADDED = 'SYSTEM_ADDED';
export const VERIFIED = 'VERIFIED';
export const PRE_VERIFIED = 'PRE-VERIFIED';
export const TOP_PROFICIT = 'TOP_PROFICIT';
export const TOP_BALANCED = 'TOP_BALANCED';
export const TOP_DEFICIT = 'TOP_DEFICIT';
export const MIDDLE_PROFICIT = 'MIDDLE_PROFICIT';
export const MIDDLE_BALANCED = 'MIDDLE_BALANCED';
export const MIDDLE_DEFICIT = 'MIDDLE_DEFICIT';
export const MIN_PROFICIT = 'MIN_PROFICIT';
export const MIN_BALANCED = 'MIN_BALANCED';
export const MIN_DEFICIT = 'MIN_DEFICIT';
export const ZERO_PARKING = 'ZERO_PARKING';
export const parkingTypes = [
    { value: DEACTIVATED, color: '#3d5cf6' },
    { value: MANUAL_ADDED, color: '#ff03bc' },
    { value: SYSTEM_ADDED, color: '#F7FE2E' },
    { value: VERIFIED, color: '#0dd75b' },
    { value: PRE_VERIFIED, color: 'red' },
];
export const parkings1300 = [
    { value: 'AGREED', color: '#d9c22d', label: defineMessage({ message: 'Согласовано' }) },
    { value: 'APPLICATION_SUBMITTED', color: '#452ef0', label: defineMessage({ message: 'Подано заявление' }) },
    { value: 'PAID_FOR_PERIOD', color: '#33a02c', label: defineMessage({ message: 'Оплачено на период' }) },
    { value: 'REFUSED', color: '#e31a1c', label: defineMessage({ message: 'Отказано' }) },
    { value: 'NOT_SUBMITTED', color: '3e3e3e', label: defineMessage({ message: 'Не подано' }) },
];
export const parkingsAlerts = [
    { value: 'PERMITTED', color: 'green', label: defineMessage({ message: 'Разрешено' }) },
    { value: 'LIMITED', color: 'orange', label: defineMessage({ message: 'Алерт' }) },
    { value: 'DENIED', color: 'red', label: defineMessage({ message: 'Запрет парковки' }) },
];
export const ClassifiedParkingTypes = [
    { value: TOP_PROFICIT, color: 'green' },
    { value: TOP_BALANCED, color: 'yellow' },
    { value: TOP_DEFICIT, color: 'red' },
    { value: MIDDLE_PROFICIT, color: 'green' },
    { value: MIDDLE_BALANCED, color: 'yellow' },
    { value: MIDDLE_DEFICIT, color: 'red' },
    { value: MIN_PROFICIT, color: 'green' },
    { value: MIN_BALANCED, color: 'yellow' },
    { value: MIN_DEFICIT, color: 'red' },
    { value: ZERO_PARKING, color: 'white' },
];
export const ClassParkingTypes = [
    { value: 'top', label: defineMessage({ message: 'Топовые' }), color: 'grey' },
    { value: 'middle', label: defineMessage({ message: 'Средние' }), color: 'grey' },
    { value: 'min', label: defineMessage({ message: 'Минимальные' }), color: '#0dd75b' },
    { value: 'less_5', label: defineMessage({ message: 'Стартов и финишей меньше 5' }), color: 'pink' },
    { value: 'zero', label: defineMessage({ message: 'Нулевые' }), color: 'white' },
];
export const ClassParkingRebalancedTypes = [
    { value: 'top', label: defineMessage({ message: 'Топовые' }), color: 'grey' },
    { value: 'middle', label: defineMessage({ message: 'Средние' }), color: 'grey' },
    { value: 'min', label: defineMessage({ message: 'Минимальные' }), color: '#0dd75b' },
    { value: 'less_5', label: defineMessage({ message: 'Ребаланса менее 5' }), color: 'pink' },
    { value: 'zero', label: defineMessage({ message: 'Нулевые' }), color: 'white' },
];
export const ClassParkingDayPartTypes = [
    { value: 1, label: defineMessage({ message: 'Ночь (0-5)' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: 2, label: defineMessage({ message: 'Утро (6-11)' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: 3, label: defineMessage({ message: 'День (12-15)' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: 4, label: defineMessage({ message: 'Вечер (16-19)' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: 5, label: defineMessage({ message: 'Поздний вечер (20-23)' }), color: 'hsla(301, 98%, 24%, 0)' },
];
export const ParkingsBookingsTypes = [
    { value: 15, label: defineMessage({ message: 'Последние 15 минут' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: 1, label: defineMessage({ message: 'Вчера' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: 7, label: defineMessage({ message: 'Неделя' }), color: 'hsla(301, 98%, 24%, 0)' },
];
export const ClassifiedParkingLegend = [
    { fill: 'red', label: defineMessage({ message: 'Дефицит' }) },
    { fill: 'yellow', label: defineMessage({ message: 'Баланс' }) },
    { fill: 'green', label: defineMessage({ message: 'Профицит' }) },
];
export const supposedBikePathStages = [
    { value: defineMessage({ message: 'Этап {0}', values: { 0: 1 } }), color: '#ffff0d' },
    { value: defineMessage({ message: 'Этап {0}', values: { 0: 2 } }), color: '#50C1E9' },
    { value: defineMessage({ message: 'Этап {0}', values: { 0: 3 } }), color: '#EAEAEA' },
];
export const ACTIVE = 'ACTIVE';
export const PROPOSED_PERMITTED = 'PROPOSED_PERMITTED';
export const PROPOSED_FORBIDDEN = 'PROPOSED_FORBIDDEN';
export const LIMITED = 'LIMITED';
export const FORBIDDEN = 'FORBIDDEN';
export const PERMITTED = 'PERMITTED';
export const PERMITTED_FICTITIOUS = 'PERMITTED_FICTITIOUS';
export const functionalAreasTypes = [
    { value: LIMITED, label: defineMessage({ message: 'Зона катания' }), color: 'green' },
    { value: FORBIDDEN, label: defineMessage({ message: 'Зона запрета катания' }), color: 'red' },
    { value: PROPOSED_FORBIDDEN, label: defineMessage({ message: 'Предлагаемая зона запрета катания' }), color: 'pink' },
    { value: PERMITTED, label: defineMessage({ message: 'Зона парковок' }), color: 'yellow' },
    { value: PERMITTED_FICTITIOUS, label: defineMessage({ message: 'Зона парковок (фиктивная)' }), color: 'yellow' },
    { value: PROPOSED_PERMITTED, label: defineMessage({ message: 'Предлагаемая зона парковок' }), color: '#00ae9d' },
];
export const competitorsRestrictionZonesTypes = [
    { value: 'no_parking', label: defineMessage({ message: 'Зона запрета парковки' }), color: '#256B87' },
    { value: 'no_entry', label: defineMessage({ message: 'Зона запрета катания' }), color: 'red' },
    { value: 'speed_limit', label: defineMessage({ message: 'Зона ограничения скорости' }), color: '#d4a9fc' },
];
export const functionalAreasYandexUrentTypes = [
    { value: 'Yandex',     label: defineMessage({ message: 'Yandex' }),     fill: '#fedf3e' },
    { value: 'Urent',      label: defineMessage({ message: 'Urent' }),      fill: '#804aff' },
    { value: 'Jet',        label: defineMessage({ message: 'Jet' }),        fill: '#2f7fe2' },
    { value: 'Lime',       label: defineMessage({ message: 'Lime' }),       fill: '#00dd01' },
    { value: 'Bolt',       label: defineMessage({ message: 'Bolt' }),       fill: '#298558' },
    { value: 'SmartBike',  label: defineMessage({ message: 'Smart Bike' }),  fill: '#81b388' },
    { value: 'Voi',        label: defineMessage({ message: 'Voi' }),        fill: '#f26960' },
    { value: 'LetsGo',     label: defineMessage({ message: 'Let\'s Go' }),  fill: '#5fe39b' },
    { value: 'Eleven',     label: defineMessage({ message: 'Eleven' }),     fill: '#ffbf00' },
    { value: 'Lite',       label: defineMessage({ message: 'Lite' }),       fill: '#66c2ff' },
    // Yango — зарубежный бренд Яндекса; Yandex/Yango — город виден в обоих приложениях
    { value: 'Yango',        label: defineMessage({ message: 'Yango' }),        fill: '#f70000' },
    { value: 'Yandex/Yango', label: defineMessage({ message: 'Yandex/Yango' }), fill: '#f70000' },
];
export const functionalAreasOperatorTypesWithWhoosh = [
    { value: 'Whoosh', label: defineMessage({ message: 'Whoosh' }), fill: '#808080' },
    ...functionalAreasYandexUrentTypes,
];
export const lisboaZonesTypes = [
    { value: 'No parking', label: defineMessage({ message: 'Зона запрета парковки' }), color: 'orange' },
    { value: 'Forbidden', label: defineMessage({ message: 'Зона запрета катания' }), color: 'red' },
    { value: 'Mandatory parking', label: defineMessage({ message: 'Обязательная парковка' }), color: 'yellow' },
];
export const initialAuthForm = {
    password: '',
    login: '',
    newPassword: '',
};
export const authFormInputs = [
    { id: 'login', type: 'email', label: defineMessage({ message: 'Логин' }) },
    { id: 'password', type: 'password', label: defineMessage({ message: 'Пароль' }) },
];
export const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';
export const ERROR_NOTIFICATION = 'ERROR_NOTIFICATION';
export const severityNotificationsDict = { ERROR_NOTIFICATION: 'error' };
export const GUEST = 'GUEST';
export const ADMIN = 'ADMIN';
export const SUPER_ADMIN = 'SUPER_ADMIN';
export const URBANIST = 'URBANIST';
export const DESIGNER = 'DESIGNER';
export const aggregatedTracksFilterValues = [
    { value: 'all', label: defineMessage({ message: 'Все поездки' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: 'scooters', label: defineMessage({ message: 'Самокаты' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: 'scooters_tandem', label: defineMessage({ message: 'Самокаты (тандем)' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: 'bikes', label: defineMessage({ message: 'Велосипеды' }), color: 'hsla(301, 98%, 24%, 0)' },
];
// DA-15259: продуктовые когорты (модели тарификации) для слоя треков — двухуровневый
// список. Верхний уровень — тип тарификации, второй — конкретная комбинация.
// value листа = суффикс колонки в MVT (<value>_cnt). Классификация — скрипт Revenue
// Management, см. martin.h3_route_cohort_7days.
export const aggTracksCohortValues = [
    { value: 'all', label: defineMessage({ message: 'Все поездки' }) },
    {
        value: 'per_minute',
        label: defineMessage({ message: 'Поминутка' }),
        children: [
            { value: 'per_minute_unlock',           label: defineMessage({ message: 'С анлоком' }) },
            { value: 'per_minute_no_unlock_sub',    label: defineMessage({ message: 'Без анлока, с подпиской' }) },
            { value: 'per_minute_no_unlock_no_sub', label: defineMessage({ message: 'Без анлока, без подписки' }) },
        ],
    },
    {
        value: 'pack',
        label: defineMessage({ message: 'Пакеты минут' }),
        children: [
            { value: 'pack_unlock',           label: defineMessage({ message: 'С анлоком' }) },
            { value: 'pack_no_unlock_sub',    label: defineMessage({ message: 'Без анлока, с подпиской' }) },
            { value: 'pack_no_unlock_no_sub', label: defineMessage({ message: 'Без анлока, без подписки' }) },
        ],
    },
    {
        value: 'unlimited',
        label: defineMessage({ message: 'Безлимит' }),
        children: [
            { value: 'unlimited_daily',   label: defineMessage({ message: 'Дневной' }) },
            { value: 'unlimited_weekly',  label: defineMessage({ message: 'Недельный' }) },
            { value: 'unlimited_monthly', label: defineMessage({ message: 'Месячный' }) },
        ],
    },
    {
        value: 'whoosh_pass',
        label: defineMessage({ message: 'Whoosh Pass' }),
        children: [
            { value: 'whoosh_pass_daily',   label: defineMessage({ message: 'Дневной' }) },
            { value: 'whoosh_pass_weekly',  label: defineMessage({ message: 'Недельный' }) },
            { value: 'whoosh_pass_monthly', label: defineMessage({ message: 'Месячный' }) },
        ],
    },
    { value: 'other', label: defineMessage({ message: 'Прочее' }) },
];
// Поиск листа по значению фильтра: возвращает { leaf, parent } (parent = null у листьев
// верхнего уровня). Нужен фильтру для подсветки группы и слою — для заголовка экспорта.
export const findAggTracksCohort = value => {
    for (const item of aggTracksCohortValues) {
        if (item.value === value) {
            return { leaf: item, parent: null };
        }
        const child = (item.children || []).find(({ value: childValue }) => childValue === value);

        if (child) {
            return { leaf: child, parent: item };
        }
    }

    return null;
};
// DA-15259: режим отображения метрики — абсолют или доля когорты в гексагоне
export const aggTracksCohortModeValues = [
    { value: 'abs',   label: defineMessage({ message: 'Абсолют' }) },
    { value: 'share', label: defineMessage({ message: 'Доля' }) },
];
// DA-15415: когорты пользователей для слоя треков — двухуровневый список.
// Верхний уровень = разрез (он же query-param dimension в MVT-функции), второй —
// бакет внутри разреза. value листа = суффикс колонки в MVT (<value>_cnt).
// Разрезы независимы и не перемножаются: тайл несёт бакеты одного разреза плюс all_cnt.
export const userCohortsValues = [
    { value: 'all', label: defineMessage({ message: 'Все поездки' }) },
    {
        value: 'age',
        label: defineMessage({ message: 'Возраст' }),
        children: [
            { value: 'age_lt18',      label: defineMessage({ message: 'До 18' }) },
            { value: 'age_age18_45',  label: defineMessage({ message: '18–45' }) },
            { value: 'age_age46_70',  label: defineMessage({ message: '46–70' }) },
            { value: 'age_age71plus', label: defineMessage({ message: '71 и старше' }) },
            { value: 'age_unknown',   label: defineMessage({ message: 'Не указан' }) },
        ],
    },
    {
        value: 'gender',
        label: defineMessage({ message: 'Пол' }),
        children: [
            { value: 'gender_male',    label: defineMessage({ message: 'Мужской' }) },
            { value: 'gender_female',  label: defineMessage({ message: 'Женский' }) },
            { value: 'gender_unknown', label: defineMessage({ message: 'Не указан' }) },
        ],
    },
    {
        value: 'tenure',
        label: defineMessage({ message: 'Стаж' }),
        children: [
            { value: 'tenure_newbie',  label: defineMessage({ message: 'Новички (до 30 дней)' }) },
            { value: 'tenure_active',  label: defineMessage({ message: 'Активные (1–12 месяцев)' }) },
            { value: 'tenure_veteran', label: defineMessage({ message: 'Старожилы (больше года)' }) },
            { value: 'tenure_unknown', label: defineMessage({ message: 'Не определён' }) },
        ],
    },
    {
        value: 'verification',
        label: defineMessage({ message: 'Верификация' }),
        children: [
            { value: 'verification_mos_ru',  label: defineMessage({ message: 'mos.ru' }) },
            { value: 'verification_sber',    label: defineMessage({ message: 'Сбер' }) },
            { value: 'verification_tinkoff', label: defineMessage({ message: 'Т-Банк' }) },
            { value: 'verification_alfa',    label: defineMessage({ message: 'Альфа' }) },
            { value: 'verification_none',    label: defineMessage({ message: 'Без верификации' }) },
        ],
    },
];
// Поиск листа по значению фильтра: возвращает { leaf, parent } (parent = null у «Всех
// поездок»). Нужен фильтру для подсветки разреза и слою — для заголовка экспорта.
export const findUserCohort = value => {
    for (const item of userCohortsValues) {
        if (item.value === value) {
            return { leaf: item, parent: null };
        }
        const child = (item.children || []).find(({ value: childValue }) => childValue === value);

        if (child) {
            return { leaf: child, parent: item };
        }
    }

    return null;
};

// DA-15415: периоды слоя треков по когортам. Три первых значения читаются из недельной
// таблицы, месяцы — из отдельной h3_route_user_cohorts_months; выбор источника делает
// сама MVT-функция по значению period, для фронта это один слой с разными периодами.
// «Месяц» — чисто группировка: значением period он не бывает, клик по нему выбирает
// первый месяц. Список месяцев адхоковый и растёт по мере пересчёта модели.
export const userCohortsPeriodValues = [
    { value: 'week', label: defineMessage({ message: 'Неделя' }) },
    { value: 'weekdays', label: defineMessage({ message: 'Будни' }) },
    { value: 'weekends', label: defineMessage({ message: 'Выходные' }) },
    {
        value: 'month',
        label: defineMessage({ message: 'Месяц' }),
        children: [
            { value: 'may2025', label: defineMessage({ message: 'Май 2025' }) },
            { value: 'aug2025', label: defineMessage({ message: 'Август 2025' }) },
            { value: 'sep2025', label: defineMessage({ message: 'Сентябрь 2025' }) },
            { value: 'may2026', label: defineMessage({ message: 'Май 2026' }) },
            { value: 'jul2026', label: defineMessage({ message: 'Июль 2026' }) },
            { value: 'aug2026', label: defineMessage({ message: 'Август 2026' }) },
        ],
    },
];

// Поиск периода по значению — как findUserCohort, но группа верхнего уровня («Месяц»)
// сама периодом не является и вернётся только как parent.
export const findUserCohortPeriod = value => {
    for (const item of userCohortsPeriodValues) {
        if (item.value === value && !item.children) {
            return { leaf: item, parent: null };
        }
        const child = (item.children || []).find(({ value: childValue }) => childValue === value);

        if (child) {
            return { leaf: child, parent: item };
        }
    }

    return null;
};
export const aggregatedTracksDayFilterValues = [
    { value: 'week', label: defineMessage({ message: 'Неделя' }) },
    { value: 'weekdays', label: defineMessage({ message: 'Будни' }) },
    { value: 'weekends', label: defineMessage({ message: 'Выходные' }) },
];
// Taps
export const aggUserTapsLegend7days = [
    { fill: 'hsla(242, 89%, 28%, 0.5)', label: '< 50' },
    { fill: '#792282', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 50, 1: 100 } }) },
    { fill: '#c23b75', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 100, 1: 300 } }) },
    { fill: '#f4695c', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 300, 1: 500 } }) },
    { fill: '#feb47b', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 500, 1: 700 } }) },
    { fill: '#fcfdbf', label: '> 700' },
];
export const aggUserTapsLegend30days = [
    { fill: 'hsla(242, 89%, 28%, 0.5)', label: '< 50' },
    { fill: '#792282', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 50, 1: 100 } }) },
    { fill: '#c23b75', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 100, 1: 300 } }) },
    { fill: '#f4695c', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 300, 1: 500 } }) },
    { fill: '#feb47b', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 500, 1: 700 } }) },
    { fill: '#fcfdbf', label: '> 700' },
];
// Taps local Moran's I
export const clusteredTapsLegend7days = [
    { fill: 'red', label: 'HH' },
    { fill: '#ffb2b2', label: 'HL' },
    { fill: '#89CFF0', label: 'LH' },
    { fill: '#0096FF', label: 'LL' },
];
// Alerts local Moran's I
export const clusteredAlerts = [
    { fill: 'red', label: defineMessage({ message: 'Высокая' }) },
    { fill: '#ffb2b2', label: defineMessage({ message: 'Средневысокая' }) },
    { fill: '#89CFF0', label: defineMessage({ message: 'Пониженная' }) },
    { fill: '#0096FF', label: defineMessage({ message: 'Низкая' }) },
];
export const AlertsTypesFilterValues = [
    { value: 1, label: 'DENIED' },
    { value: 2, label: 'LIMITED' },
    { value: 3, label: 'PERMITTED' },
];
export const AlertsDeviceTypesFilterValues = [
    { value: 1, label: 'DEVICE' },
    { value: 2, label: 'PHONE' },
];
export const ClassifiedParkingDayweekFilterValues = [
    { value: 0, label: defineMessage({ message: 'Будни' }) },
    { value: 1, label: defineMessage({ message: 'Выходные' }) },
    // { value: 2, label: defineMessage({ message: 'Вчера' }) },
];

export const DowntimeParkingsPeriodFilterValues = [
    { value: 7, label: defineMessage({ message: '7 дней' }) },
    { value: 20240801, label: defineMessage({ message: 'Август 2024' }) },
    { value: 20250801, label: defineMessage({ message: 'Август 2025' }) },
    { value: 20260801, label: defineMessage({ message: 'Август 2026' }) },
];

export const ClassifiedParkingRebalancedDayweekFilterValues = [
    { value: 0, label: defineMessage({ message: 'Будни' }) },
    { value: 1, label: defineMessage({ message: 'Выходные' }) },
];

export const ClassifiedParkingLastDayFilterValues = [
    { fill: 'white', label: defineMessage({ message: 'Вчера' }), value: 'last_day' },
];
// Opens
export const aggUserOpensLegend7days = [
    { fill: 'hsla(242, 89%, 28%, 0.5)', label: '< 200' },
    { fill: '#792282', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 200, 1: 500 } }) },
    { fill: '#c23b75', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 500, 1: 800 } }) },
    { fill: '#f4695c', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 800, 1: 1200 } }) },
    { fill: '#feb47b', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 1200, 1: 2000 } }) },
    { fill: '#fcfdbf', label: '> 2000' },
];
export const aggUserOpensLegend30days = [
    { fill: 'hsla(242, 89%, 28%, 0.5)', label: '< 500' },
    { fill: '#792282', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 500, 1: 1000 } }) },
    { fill: '#c23b75', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 1000, 1: 2000 } }) },
    { fill: '#f4695c', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 2000, 1: 3000 } }) },
    { fill: '#feb47b', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 3000, 1: 5000 } }) },
    { fill: '#fcfdbf', label: '> 5000' },
];
// Taps with zero starts
export const aggUserTapsZeroStartsLegend7days = [
    { fill: 'hsla(242, 89%, 28%, 0.5)', label: '< 30' },
    { fill: '#792282', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 30, 1: 70 } }) },
    { fill: '#c23b75', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 70, 1: 100 } }) },
    { fill: '#f4695c', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 100, 1: 150 } }) },
    { fill: '#feb47b', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 150, 1: 300 } }) },
    { fill: '#fcfdbf', label: '> 300' },
];
export const aggUserTapsZeroStartsLegend30days = [
    { fill: 'hsla(242, 89%, 28%, 0.5)', label: '< 400' },
    { fill: '#792282', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 400, 1: 1000 } }) },
    { fill: '#c23b75', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 1000, 1: 2000 } }) },
    { fill: '#f4695c', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 2000, 1: 3000 } }) },
    { fill: '#feb47b', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 3000, 1: 4000 } }) },
    { fill: '#fcfdbf', label: '> 4000' },
];
// Opens to starts
export const aggUserOpensToStartsLegend = [
    { fill: '#03559F', label: '< 3' },
    { fill: '#792282', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 3, 1: 6 } }) },
    { fill: '#c23b75', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 6, 1: 12 } }) },
    { fill: '#f4695c', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 12, 1: 50 } }) },
    { fill: '#feb47b', label: defineMessage({ message: 'от {0} до {1}', values: { 0: 50, 1: 100 } }) },
    { fill: '#fcfdbf', label: '> 100' },
];
export const downtimeScootersLegend = [
    { color: 'green', label: defineMessage({ message: '< 2' }), value: '0' },
    { color: 'lightgreen', label: defineMessage({ message: '2-4' }), value: '1' },
    { color: 'white', label: defineMessage({ message: '4-6' }), value: '2' },
    { color: 'yellow', label: defineMessage({ message: '6-9' }), value: '3' },
    { color: 'orange', label: defineMessage({ message: '9-12' }), value: '4' },
    { color: '#b35500', label: defineMessage({ message: '12-24' }), value: '5' },
    { color: 'red', label: defineMessage({ message: '24-48' }), value: '6' },
    { color: '#8B0000', label: defineMessage({ message: '>= 48' }), value: '7' },
];
export const aggStartAugustLegend = [
    { value: '2025', label: defineMessage({ message: '2025' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: '2024', label: defineMessage({ message: '2024' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: '2023', label: defineMessage({ message: '2023' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: '2022', label: defineMessage({ message: '2022' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: '2021', label: defineMessage({ message: '2021' }), color: 'hsla(301, 98%, 24%, 0)' },
];
export const aggFinishAugustLegend = [
    { value: '2025', label: defineMessage({ message: '2025' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: '2024', label: defineMessage({ message: '2024' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: '2023', label: defineMessage({ message: '2023' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: '2022', label: defineMessage({ message: '2022' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: '2021', label: defineMessage({ message: '2021' }), color: 'hsla(301, 98%, 24%, 0)' },
];

export const aggregatedDiffStartFinish = [
    { fill: '#d7191c', label: defineMessage({ message: 'Финишей значительно больше (на ≥ 50)' }) },
    { fill: '#fdae61', label: defineMessage({ message: 'Финишей больше (на 5 - 50)' }) },
    { fill: '#ffffbf', label: defineMessage({ message: 'Баланс стартов и финишей' }) },
    { fill: '#abd9e9', label: defineMessage({ message: 'Стартов больше (на 5 - 50)' }) },
    { fill: '#2c7bb6', label: defineMessage({ message: 'Стартов значительно больше (на ≥ 50)' }) },
];
export const aggregatedDiffStartFinishAugust = [
    { fill: '#d7191c', label: defineMessage({ message: 'Финишей значительно больше (на ≥ 100)' }) },
    { fill: '#f17c4a', label: defineMessage({ message: 'Финишей больше (на 50 - 100)' }) },
    { fill: '#fec980', label: defineMessage({ message: 'Финишей больше (на 15 - 50)' }) },
    { fill: '#ffffbf', label: defineMessage({ message: 'Разница стартов/финишей менее 15' }) },
    { fill: '#c7e9ad', label: defineMessage({ message: 'Стартов больше (на 15 - 50)' }) },
    { fill: '#80bfac', label: defineMessage({ message: 'Стартов больше (на 50 - 100)' }) },
    { fill: '#2b83ba', label: defineMessage({ message: 'Стартов значительно больше (на ≥ 100)' }) },
];
export const aggregatedDiffStartFinishAugustFilter = [
    { value: '2025', label: defineMessage({ message: '2025' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: '2024', label: defineMessage({ message: '2024' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: '2023', label: defineMessage({ message: '2023' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: '2022', label: defineMessage({ message: '2022' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: '2021', label: defineMessage({ message: '2021' }), color: 'hsla(301, 98%, 24%, 0)' },
];
export const population = [
    { fill: '#30123b', label: defineMessage({ message: '{0} человек', values: { 0: '< 1000' } }) },
    { fill: '#4664da', label: defineMessage({ message: '{0} человек', values: { 0: '≥ 1000' } }) },
    { fill: '#1ad2d2', label: defineMessage({ message: '{0} человек', values: { 0: '≥ 2000' } }) },
    { fill: '#88ff4e', label: defineMessage({ message: '{0} человек', values: { 0: '≥ 3000' } }) },
    { fill: '#d4e735', label: defineMessage({ message: '{0} человек', values: { 0: '≥ 4000' } }) },
    { fill: '#fea732', label: defineMessage({ message: '{0} человек', values: { 0: '≥ 5000' } }) },
    { fill: '#7a0403', label: defineMessage({ message: '{0} человек', values: { 0: '≥ 10000' } }) },
];
export const landuseLegend = [
    { fill: '#f891ff', label: defineMessage({ message: 'плохое' }) },
    { fill: '#ff9100', label: defineMessage({ message: 'хорошее' }) },
    { fill: 'yellow', label: defineMessage({ message: 'частный сектор' }) },
];
export const poiLegend = [
    { color: '#FF4081', label: defineMessage({ message: 'Еда' }), value: 'food' },
    { color: '#FFE57F', label: defineMessage({ message: 'Магазины' }), value: 'shop' },
    { color: '#CCFF90', label: defineMessage({ message: 'Развлечения' }), value: 'leisure' },
    { color: '#84FFFF', label: defineMessage({ message: 'Офисы' }), value: 'office' },
    { color: 'yellow', label: defineMessage({ message: 'Сервис' }), value: 'service' },
    { color: '#E6E6FA', label: defineMessage({ message: 'Образование' }), value: 'schools_and_kindergartens' },
    { color: 'orange', label: defineMessage({ message: 'Высшее образование' }), value: 'higher_education' },
    { color: '#d54dff', label: defineMessage({ message: 'Доставка' }), value: 'delivery' },
    { color: 'red', label: defineMessage({ message: 'Туризм' }), value: 'tourism' },
    { color: '#448AFF', label: defineMessage({ message: 'Транспорт' }), value: 'transport' },
    { color: '#448AFF', label: defineMessage({ message: 'Вход в метро' }), value: 'subway_entrance' },
    { color: '#808000', label: defineMessage({ message: 'Велопарковки' }), value: 'parkings' },
];
export const SbWithErrors = [
    { color: '#CC2828', label: defineMessage({ message: '21 (Контакт с АКБ)' }), value: '21' },
    { color: '#AA0CB0', label: defineMessage({ message: '50 (Тип АКБ)' }), value: '50' },
];
export const speedLimitsLegend = [
    { color: '#d4a9fc', label: defineMessage({ message: 'Ограничения скорости' }), value: 'SPEED_LIMIT' },
    { color: '#256B87', label: defineMessage({ message: 'Запрета парковки (без паузы)' }), value: 'STOP_LIMIT' },
    { color: 'green', label: defineMessage({ message: 'Запрета парковки (с паузой)' }), value: 'STOP_LIMIT_with_pause' },
];
export const PanoramasLegend = [
    { color: 'white', label: defineMessage({ message: 'Включить панорамы' }), value: '1' },
];
export const RotationLegend = [
    { color: 'white', label: defineMessage({ message: 'Статистики по зонам' }), value: '1' },
];
export const RotationLegendV2 = [
    { color: 'white', label: defineMessage({ message: 'Показать Rotation v2' }), value: '1' },
];

// DA-12016: варианты тематической раскладки по операционным зонам
export const OaRotationMetricOptions = [
    { value: 'trips',    label: defineMessage({ message: 'Старты' }) },
    { value: 'fleet',    label: defineMessage({ message: 'Флот' }) },
    { value: 'rotation', label: defineMessage({ message: 'Оборот' }) },
];

// DA-12016: типы операторов для DynamicAttributeFilter (rotation / trips / fleet)
export const OaRotationDevOperatorTypes = [
    { value: 'whoosh',    label: defineMessage({ message: 'Whoosh v1' }), fill: 'orange' },
    { value: 'whoosh_v2', label: defineMessage({ message: 'Whoosh v2' }), fill: 'orange' },
    { value: 'whoosh_v3', label: defineMessage({ message: 'Whoosh v3' }), fill: 'orange' },
    { value: 'yandex',   label: defineMessage({ message: 'Yandex' }),    fill: '#f8f32b' },
    { value: 'urent',    label: defineMessage({ message: 'Urent' }),     fill: '#804cff' },
    { value: 'jet',      label: defineMessage({ message: 'Jet' }),       fill: '#2f7fe2' },
    { value: 'gojet',    label: defineMessage({ message: 'GoJet' }),     fill: '#2f7fe2' },
    { value: 'eleven',   label: defineMessage({ message: 'Eleven' }),    fill: '#0091ad' },
    { value: 'lime',     label: defineMessage({ message: 'Lime' }),      fill: '#00dd01' },
    { value: 'lite',     label: defineMessage({ message: 'Lite' }),      fill: '#027bff' },
];
export const OaRotationOperatorTypes = [
    { value: 'whoosh', label: defineMessage({ message: 'Whoosh' }),  fill: 'orange' },
    { value: 'yandex', label: defineMessage({ message: 'Yandex' }),  fill: '#f8f32b' },
    { value: 'urent',  label: defineMessage({ message: 'Urent' }),   fill: '#804cff' },
    { value: 'jet',    label: defineMessage({ message: 'Jet' }),     fill: '#2f7fe2' },
    { value: 'gojet',  label: defineMessage({ message: 'GoJet' }),   fill: '#2f7fe2' },
    { value: 'eleven', label: defineMessage({ message: 'Eleven' }),  fill: '#0091ad' },
    { value: 'lime',   label: defineMessage({ message: 'Lime' }),    fill: '#00dd01' },
    { value: 'lite',   label: defineMessage({ message: 'Lite' }),    fill: '#027bff' },
];
export const newBuildingsLegend = [
    { fill: '#cf00cc', label: defineMessage({ message: 'Типовой' }) },
    { fill: '#3d5cf6', label: defineMessage({ message: 'Комфорт' }) },
    { fill: '#0dd75b', label: defineMessage({ message: 'Бизнес' }) },
    { fill: '#F7FE2E', label: defineMessage({ message: 'Элитный' }) },
    { fill: 'red', label: defineMessage({ message: 'Другое' }) },
];
export const ParkingRadiusLegendStatuses = [
    { fill: 'red', label: defineMessage({ message: 'Менее {0} м', values: { 0: 15 } }) },
    { fill: 'white', label: defineMessage({ message: 'от {0} м до {1} м', values: { 0: 15, 1: 25 } }) },
    { fill: 'green', label: defineMessage({ message: '{0} м', values: { 0: 25 } }) },
    { fill: 'yellow', label: defineMessage({ message: 'Более {0} м', values: { 0: 25 } }) },
];
export const Legend = [
    { fill: 'white', label: defineMessage({ message: 'Менее 20 м' }) },
    { fill: 'yellow', label: defineMessage({ message: '20 м' }) },
    { fill: 'green', label: defineMessage({ message: 'Более 20 м' }) },
];
export const aggFailedTripsLegend7days = [
    { fill: 'hsla(242, 89%, 28%, 0.6)', label: '< 10%' },
    { fill: '#792282', label: defineMessage({ message: 'от {0}% до {1}%', values: { 0: 10, 1: 30 } }) },
    { fill: '#c23b75', label: defineMessage({ message: 'от {0}% до {1}%', values: { 0: 30, 1: 50 } }) },
    { fill: '#f4695c', label: defineMessage({ message: 'от {0}% до {1}%', values: { 0: 50, 1: 70 } }) },
    { fill: '#feb47b', label: defineMessage({ message: 'от {0}% до {1}%', values: { 0: 70, 1: 100 } }) },
    { fill: '#fcfdbf', label: '> 100%' },
];
export const isochroneFilterValues = [ 100, 200, 400, 800 ];
export const isochronesWithScootersFilterValues = [
    { fill: '#369ac2', label: defineMessage({ message: 'Все изохроны' }), value: '0' },
    { fill: 'red', label: defineMessage({ message: 'Изохроны с самокатами' }), value: '1' },
];
export const CurrentScootersFilterValues = [
    { fill: 'white', label: defineMessage({ message: '0 самокатов' }), value: '0' },
    { fill: 'yellow', label: defineMessage({ message: '1 самокат' }), value: '1' },
    { fill: '#c572ee', label: defineMessage({ message: '2+ самокатов' }), value: '2' },
];
export const ParkingRadiusValues = [
    { fill: 'green', label: defineMessage({ message: 'Permitted' }), value: '1' },
    { fill: 'orange', label: defineMessage({ message: 'Limited' }), value: '0' },
];
export const aggTracksFilterValues = [
    { value: '2019', label: defineMessage({ message: '2019' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: '2020', label: defineMessage({ message: '2020' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: '2021', label: defineMessage({ message: '2021' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: '2022', label: defineMessage({ message: '2022' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: '2023', label: defineMessage({ message: '2023' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: '2024', label: defineMessage({ message: '2024' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: '2025', label: defineMessage({ message: '2025' }), color: 'hsla(301, 98%, 24%, 0)' },
];

export const AnalyticAreasFilterTypes = [
    { value: 0, label: defineMessage({ message: 'Транспортный каркас' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: 1, label: defineMessage({ message: 'Бизнес' }), color: 'hsla(301, 98%, 24%, 0)' },
];

export const ParkingsAlertsPointsPeriodFilterValues = [ 1, 3, 7 ];
export const ParkingsAlertsDeviceFilterValues = [
    { fill: '#6495ED', label: defineMessage({ message: 'PHONE' }), value: 'PHONE' },
    { fill: '#E34234', label: defineMessage({ message: 'DEVICE' }), value: 'DEVICE' },
];
export const ParkingsAlertsPointsTypeErrorFilterValues = [
    { value: 1,  label: 'DEVICE_LIMITEXT_ONLINE__PHONE_LIMITEXT', color: '#E34234' },
    { value: 2,  label: 'DEVICE_DENIED',                          color: '#E34234' },
    { value: 3,  label: 'DEVICE_OFFLINE__PHONE_LIMITEXT',         color: '#6495ED' },
    { value: 4,  label: 'DENIED_BY_FORBIDDEN_AREA',               color: '#E34234' },
    { value: 5,  label: 'DENIED_BY_NO_LOCKING_AREA',              color: '#E34234' },
    { value: 7,  label: 'SMS_FORBIDDEN_PARKING',                  color: '#E34234' },
    { value: 9,  label: 'DEVICE_DENIED__PHONE_NOGEO',             color: '#E34234' },
    { value: 10, label: 'RESTRICTED_FOR_TYPE_AREA',               color: '#E34234' },
    { value: 11, label: 'DEVICE_NOGEO__PHONE_LIMITEXT',           color: '#6495ED' },
    { value: 12, label: 'All cases',                              color: 'White' },
];

export const isochronesServiceCentersFilterValues = [ 2, 15, 30 ];
export const ServiceCentersFilterValues = [
    { fill: '#00c04b', label: defineMessage({ message: 'Фактическая инфраструктура' }), value: 'ACTIVE' },
    { fill: '#89CFF0', label: defineMessage({ message: 'Сервисный центр' }), value: 'СЦ' },
    { fill: 'red', label: defineMessage({ message: 'Станция зарядки' }), value: 'СЗ' },
    { fill: 'blue', label: defineMessage({ message: 'Шкаф' }), value: 'Шкаф' },
    { fill: 'orange', label: defineMessage({ message: 'Планируемая инфраструктура' }), value: 'PROSPECTIVE' },
    { fill: 'purple', label: defineMessage({ message: 'Перспективный сервисный центр' }), value: 'ПСЦ-АДМИН' },
    { fill: 'pink', label: defineMessage({ message: 'Перспективная станция зарядки' }), value: 'ПСЗ-АДМИН' },
    { fill: '#7B3F00', label: defineMessage({ message: 'Перспективный шкаф' }), value: 'ПШкаф' },
];
export const API_GW_URL = 'https://martinui-api.whoosh.bike';
export const MEASURE = 'MEASURE';
export const mapTools = [{ type: MEASURE, label: defineMessage({ message: 'Линейка' }) }];
export const mapStyles = {
    dark: 'mapbox://styles/whoosh-bike/cmjspvyxb009w01r0bzss8ddp',
    basic: 'mapbox://styles/whoosh-bike/cmjsqgk2q00gy01sdf7hlcrxe',
    satellite: 'mapbox://styles/whoosh-bike/cmjspw2gp00ji01sbaa8r8xnv',
    outdoors: 'mapbox://styles/whoosh-bike/cmjspw55b000o01s92u58f9s3',
};
export const MAP_STYLES = 'MAP_STYLES';
export const MAP_STYLE = 'map_style';
export const SELECTED_REGION = 'SELECTED_REGION';
export const startFinishTrackFilterValues = [ 1, 7, 30 ];
export const startsCompetitorsFilterValues = [ 1, 7, 30 ];
export const operationAreasRotationFilterValues = [ 1, 7, 14, 30 ];
export const CompetitorsFilterValues = [
    { value: 'whoosh', label: 'Whoosh' },
    { value: 'yandex', label: 'Yandex' },
    { value: 'urent', label: 'Urent' },
    { value: 'jet', label: 'Jet' },
    { value: 'eleven', label: 'Eleven' },
    { value: 'lime', label: 'Lime' },
    { value: 'lite', label: 'Lite' },
    { value: 'voi', label: 'Voi' },
];
export const userTapsFilterValues = [ 7, 30 ];
export const userTapsOpensHistYearFilterValues = [ 2024, 2025, 2026 ];
export const userTapsOpensHistFilterValues = [
    { value: 'taps', label: defineMessage({ message: 'Тапы' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: 'opens', label: defineMessage({ message: 'Открытия' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: 'open_to_ride', label: defineMessage({ message: 'Открытий к старту' }), color: 'hsla(301, 98%, 24%, 0)' },
    { value: 'taps_no_starts', label: defineMessage({ message: 'Тапы без стартов' }), color: 'hsla(301, 98%, 24%, 0)' },
];
export const aggregatedStartTracks = 'Агрегированные старты треков';
export const aggUserTaps = 'Агрегированные тапы пользователей (beta)';
export const aggregatedFinishTracks = 'Агрегированные финиши треков';
export const taps = 'Тапы пользователей';
export const opens = 'Открытия приложения';
export const ABS = 'ABS';
export const SHARE = 'SHARE';
export const trackModeOptions = [
    { type: ABS, label: ABS }, { type: SHARE, label: SHARE },
    { type: 'TANDEM', label: 'TANDEM' }, { type: 'TANDEM_SHARE', label: 'TANDEM (SHR)' },
];
export const startsCompetitorsModeOptions = [
    { type: 'starts', label: ABS }, { type: 'ms', label: 'MARKET SHARE' },
    { type: 'leadership', label: 'LEADER' },
];
export const CompetitorsLegend = [
    { color: 'orange', label: defineMessage({ message: 'Whoosh' }), value: 'whoosh' },
    { color: '#f8f32b', label: defineMessage({ message: 'Yandex' }), value: 'yandex' }, // '#ffde40'
    { color: '#804cff', label: defineMessage({ message: 'Urent' }), value: 'urent' },
    { color: '#2f7fe2', label: defineMessage({ message: 'Jet' }), value: 'jet' },
    { color: '#0091ad', label: defineMessage({ message: 'Eleven' }), value: 'eleven' },
    { color: '#00dd01', label: defineMessage({ message: 'Lime' }), value: 'lime' },
    { color: '#027bff', label: defineMessage({ message: 'Lite' }), value: 'lite' },
    { color: '#f26960', label: defineMessage({ message: 'Voi' }), value: 'voi' },
];
export const TapsOpensModeOptions = [{ type: ABS, label: ABS }, { type: SHARE, label: 'NORMALIZED' }]; // change labels if required
export const startFinishTrackHexagonColor = [ 'hsla(301, 98%, 24%, 0)', '#0d0887', 'rgb(127,3,168)', 'rgb(203,71,120)', '#f07f4f', '#f0f921' ];
export const userTapsHexagonColor = [ 'hsla(242, 89%, 28%, 0.3)', '#792282', '#c23b75', '#f4695c', '#feb47b', '#fcfdbf' ];
export const userTapsHexagonColorSh = [ '#2b83ba', '#80bfac', '#c7e9ad', '#ffffff', '#ffffbf', '#f17c4a', '#d7191c' ];

export const layersRenderOrder = [
    'Землепользование',
    'POI',
    'Жилые дома',
    'Изохроны доступности парковок',
    'Жилые дома - heatmap',
    'Новостройки',
    'Население',
    'Тапы пользователей',
    'Открытия приложения',
    'Тапы пользователей без поездок (7 дней)',
    'Тапы пользователей без поездок (30 дней)',
    'Открытий к стартам (7 дней)',
    'Открытий к стартам (30 дней)',
    'Парковки whoosh',
    'Плотность парковок',
    'Классификация парковок',
    'Велодорожки',
    'Предлагаемые велодорожки',
    'Тепловая карта неровностей на тротуарах',
    'Количество самокатов на парковках',
    'Текущий дефицит самокатов',
    'Текущий избыток самокатов',
    'Агрегированный баланс самокатов на парковках',
    'Баланс самокатов в операционных зонах',
    'Приведенный к 1 парковке баланс самокатов в операционных зонах',
    'Среднесуточное количество переходов в CHANGE_BATTERY по парковкам',
    'Среднесуточное количество самокатов в статусе CHANGE_BATTERY в операционных зонах',
    'Агрегированные треки за август 2021 года',
    'Агрегированные старты треков',
    'Агрегированные финиши треков',
    'Агрегированая разница стартов и финишей за 7 дней',
    'Агрегированая разница стартов и финишей за август 2021',
    'Агрегированные старты (август 2021)',
    'Агрегированные финиши (август 2021)',
    'Агрегированные тапы пользователей (beta)',
    'Функциональные зоны',
    'Зонирование',
    'Зоны ограничения скорости',
    'Зоны ограничения скорости_обводка',
    'Операционные зоны (rotation)',
    'Операционные зоны',
    'Операционные зоны_label',
    'Аналитические зоны',
    'Границы города',
    'Аналитические зоны_обводка',
    'deck:operation_areas_corresponding_matrix',
];

export const poiLegendValues = poiLegend.map(el => el.value);
// DA-7087: источники POI — по умолчанию показываем оба (OSM + AllThePlaces)
export const poiSourceValues = [ 'osm', 'atp' ];
export const SbWithErrorsValues = SbWithErrors.map(el => el.value);
export const downtimeScootersValues = downtimeScootersLegend.map(el => el.value);

// DA-12966: статусы потерянных самокатов
export const LostDevicesStatuses = [
    { value: 'LOST',    color: '#eab308', label: defineMessage({ message: 'LOST — потерян' }) },
    { value: 'DELETED', color: '#ef4444', label: defineMessage({ message: 'DELETED — утерян безвозвратно' }) },
];
export const LostDevicesValues = LostDevicesStatuses.map(el => el.value);

// DA-12966, DA-15988: категории гекс-слоя «Агрегированные потери» — эпизоды потери в точке потери,
// LOST = FOUND + DELETED + ещё в LOST; value — счётчик в martin.lost_devices_h3
export const LostDevicesH3Categories = [
    {
        value: 'cnt_lost_found',
        label: defineMessage({ message: 'LOST&FOUND — впоследствии найдены' }),
    },
    {
        value: 'cnt_deleted',
        label: defineMessage({ message: 'DELETED — утрачены безвозвратно' }),
    },
];

// DA-14587: типы ошибок геометрии зон
export const OperationAreaErrTypes = [
    { value: 'hole',                color: '#A3E635', label: defineMessage({ message: 'Дырка в полигоне' }) },
    { value: 'multipolygon_part',   color: '#34D399', label: defineMessage({ message: 'Лишняя часть мультиполигона' }) },
    { value: 'duplicate_feature',   color: '#22D3EE', label: defineMessage({ message: 'Дубликат объекта' }) },
    { value: 'self_intersection',   color: '#60A5FA', label: defineMessage({ message: 'Самопересечение' }) },
    { value: 'overlap',             color: '#2563EB', label: defineMessage({ message: 'Перекрытие' }) },
];
export const OperationAreaErrTypeValues = OperationAreaErrTypes.map(el => el.value);
// DA-14587: типы ошибок геометрии функциональных зон (гамма: жёлтый → тёмно-красный)
export const FunctionalAreaErrTypes = [
    { value: 'hole',                color: '#FDE047', label: defineMessage({ message: 'Дырка в полигоне' }) },
    { value: 'multipolygon_part',   color: '#F97316', label: defineMessage({ message: 'Лишняя часть мультиполигона' }) },
    { value: 'duplicate_feature',   color: '#EA580C', label: defineMessage({ message: 'Дубликат объекта' }) },
    { value: 'self_intersection',   color: '#DC2626', label: defineMessage({ message: 'Самопересечение' }) },
    { value: 'overlap',             color: '#991B1B', label: defineMessage({ message: 'Перекрытие' }) },
];


export const correspondingMatrixPeriods = [
    { value: 'week', label: defineMessage({ message: 'Неделя' }) },
    // { value: '2022', label: defineMessage({ message: 'Август 2022' }) },
    // { value: '2023', label: defineMessage({ message: 'Август 2023' }) },
];

export const aggScootersDowntimePeriodStatuses = 7;

// DA-14919 / DA-15019: метрики WalkScore — единый источник для фильтра
// (WalkscoreFilter) и заголовка экспорта растра (exportTitle слоя WalkScore).
// Все скоры лежат атрибутами одного тайла; ключ — имя атрибута в fill-color.
export const walkscoreMetricSections = [
    {
        title: defineMessage({ message: 'Общий' }),
        items: [{ key: 'r_all', label: defineMessage({ message: 'Общий WalkScore' }) }],
    },
    {
        title: defineMessage({ message: 'Группы' }),
        items: [
            { key: 'r_1', label: defineMessage({ message: 'Образование' }) },
            { key: 'r_2', label: defineMessage({ message: 'Магазины и здравоохранение' }) },
            { key: 'r_3', label: defineMessage({ message: 'Общественное питание' }) },
            { key: 'r_4', label: defineMessage({ message: 'Досуг' }) },
            { key: 'r_5', label: defineMessage({ message: 'Спорт и рекреация' }) },
        ],
    },
    {
        title: defineMessage({ message: 'Категории' }),
        items: [
            { key: 'kind', label: defineMessage({ message: 'Детские сады' }) },
            { key: 'schl', label: defineMessage({ message: 'Школы' }) },
            { key: 'univ', label: defineMessage({ message: 'ВУЗы' }) },
            { key: 'food', label: defineMessage({ message: 'Продукты' }) },
            { key: 'shop', label: defineMessage({ message: 'Магазины' }) },
            { key: 'heal', label: defineMessage({ message: 'Медицина' }) },
            { key: 'fast', label: defineMessage({ message: 'Фастфуд' }) },
            { key: 'cafe', label: defineMessage({ message: 'Кафе' }) },
            { key: 'rest', label: defineMessage({ message: 'Рестораны' }) },
            { key: 'cine', label: defineMessage({ message: 'Кинотеатры' }) },
            { key: 'thea', label: defineMessage({ message: 'Театры/музеи' }) },
            { key: 'entr', label: defineMessage({ message: 'Развлечения' }) },
            { key: 'park', label: defineMessage({ message: 'Зелёные зоны' }) },
            { key: 'bibl', label: defineMessage({ message: 'Библиотеки' }) },
            { key: 'fitn', label: defineMessage({ message: 'Спортобъекты' }) },
        ],
    },
];
// Плоская мапа key → label (descriptor) для resolve метрики по значению контрола.
export const walkscoreMetricLabels = walkscoreMetricSections.reduce((acc, section) => {
    section.items.forEach(({ key, label }) => { acc[key] = label });
    return acc;
}, {});
